export const pluralize = (count, single, multi) => {
  if (!count) {
    return null;
  }
  if (count === 1) {
    return `1 ${single}`;
  }
  return `${count} ${multi}`;
};
